import { useContext, useEffect } from 'react';
import { DateNavigator } from '@devexpress/dx-react-scheduler-material-ui';
import EDTooltip from '../../../../../../../../BaseComponents/Tooltip/EDTooltip';
import { SchedulerContext } from '../../SchedulerContext';
import EDBox from '../../../../../../../../BaseComponents/EDBox/EDBox';
import { useIsLargeScreen } from '../../../../../../../../Hooks/useFullscreenView';
import {
  firstDayInWeek,
  firstDayInMonth,
  incDay,
  dateNavigatorFormatter,
  getWeekDayText2,
  getDay,
} from '../../../../../../../../Utils/dateUtils';
import { dateToStr } from '../../../../../../../../Utils/stringUtils';
import { ViewDbSettingsContext } from '../ViewDbSettingsContext';

interface IDateNavigatorRootComponentProps extends DateNavigator.RootProps {
  overview?: boolean; // The overview prop can be a boolean
}

export const DateNavigatorRootComponent = (
  props: IDateNavigatorRootComponentProps
) => {
  const schedulerContext = useContext(SchedulerContext);
  const setOnNavigate = schedulerContext.setOnNavigate;
  const isLargeScreen = useIsLargeScreen();
  const viewDbSettingsContext = useContext(ViewDbSettingsContext);
  const currentDate = viewDbSettingsContext.currentDate ?? new Date();
  const currentView = viewDbSettingsContext.currentView ?? 'Week';
  const startDay =
    currentView === 'Month'
      ? dateToStr(firstDayInWeek(firstDayInMonth(currentDate)))
      : dateToStr(firstDayInWeek(currentDate));
  const endDay =
    currentView === 'Month'
      ? dateToStr(incDay(firstDayInWeek(firstDayInMonth(currentDate)), 6))
      : currentView === 'Day'
      ? startDay
      : dateToStr(incDay(firstDayInWeek(currentDate), 6));
  useEffect(() => {
    setOnNavigate(() => props.onNavigate);
  }, [props.onNavigate, setOnNavigate]);

  const navigatorText =
    currentView == 'Week'
      ? dateNavigatorFormatter(startDay, endDay)
      : props.navigatorText;

  const showOverview = props.overview !== undefined ? props.overview : false;

  const newProps = {
    navigationButtonComponent: props.navigationButtonComponent,
    openButtonComponent: props.openButtonComponent,
    rootRef: props.rootRef,
    onVisibilityToggle: props.onVisibilityToggle,
    onNavigate: props.onNavigate,
    navigatorText:
      currentView === 'Day'
        ? showOverview
          ? `${getWeekDayText2(currentDate).substring(0, 3)} ${getDay(
              currentDate
            )} ${navigatorText?.replace(/^[^A-Za-z]+/, '').substring(0, 3)} ${
              navigatorText?.replace(/^[^A-Za-z]+/, '').split(' ')[1]
            }`
          : navigatorText?.replace(/^[^A-Za-z]+/, '')
        : navigatorText,
  };
  return (
    <EDTooltip title="Datumväljare">
      <EDBox sx={{ minWidth: isLargeScreen ? '300px' : undefined }}>
        <DateNavigator.Root {...newProps}></DateNavigator.Root>
      </EDBox>
    </EDTooltip>
  );
};
